import { render, staticRenderFns } from "./NavbarItems.vue?vue&type=template&id=94183d46&"
import script from "./NavbarItems.vue?vue&type=script&lang=js&"
export * from "./NavbarItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports